<template>
    <div class="detail">
        <div class="top-content main_content">
            <TopMenus v-model="activeIndex"></TopMenus>
        </div>
        <div class="banner-box">
            <div class="main_content banner-content">
                <div class="banner">
                    <el-carousel indicator-position="outside" arrow="always" height="338rem">
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/BiaoQian/KM-118D/images/118D-1.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/BiaoQian/KM-118D/images/118D-1.27.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/BiaoQian/KM-118D/images/118D-6.29.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/BiaoQian/KM-118D/images/118D-8.30.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/BiaoQian/KM-118D/images/118D-14.250.png" alt="img"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="info">
                    <div class="title"><span class="other-color">KM-118</span>系列面单打印机</div>
                    <div class="sub-title">可选203/300dpi，支持多规格标签和面单打印</div>
                    <div class="text">
                        通讯接口：usb、蓝牙（可选）<br/>
                        打印速度：150-180mm/S<br/>
                        打印宽度：max108mm<br/>
                        适用：电商、快递物流等面单打印
                    </div>
                </div>
            </div>
        </div>
        <template v-if="activeIndex===0">
            <div class="main_content content-bg">
                <img src="./images/1.jpg" alt="bg">
                <img src="./images/2.jpg" alt="bg">
                <img src="./images/3.jpg" alt="bg">
                <img src="./images/4.jpg" alt="bg">
                <img src="./images/5.jpg" alt="bg">
                <img src="./images/6.jpg" alt="bg">
                <img src="./images/7.jpg" alt="bg">
                <img src="./images/8.jpg" alt="bg">
                <img src="./images/9.jpg" alt="bg">
                <img src="./images/10.jpg" alt="bg">
                <img src="./images/11.jpg" alt="bg">
                <img src="./images/12.jpg" alt="bg">
                <img src="./images/13.jpg" alt="bg">
                <img src="./images/14.jpg" alt="bg">
                <img src="./images/15.jpg" alt="bg">
                <img src="./images/16.jpg" alt="bg">

            </div>
        </template>
        <div v-else-if="activeIndex===1" class="content-bg-cs"></div>
    </div>
</template>

<script>
import TopMenus from '@/views/printCenter/TopMenus.vue'

export default {
    name: "deviceDetail",
    components: {TopMenus},
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../printCenter.scss";

.detail {
    .content-bg {
        img {
            width: 100%;
        }
    }

    .content-bg-cs {
    }
}
</style>
